import { UpdateShipmentOrderPackagesSOP } from '@tecex-api/data';
import { ChargeableWeightDialogResult } from '../interfaces/chargeable-weight-dialog.vm';
import { mapDimensionsUnitPayload } from './map-dimensions-unit-payload.helper';
import { mapWeightUnitPayload } from './map-weight-unit-payload.helper';
import { roundDecimal } from './utils.helper';

export const mapUpdatePackagesPayload = (payload: ChargeableWeightDialogResult): UpdateShipmentOrderPackagesSOP[] =>
  payload.packages.map((shipmentPackage) => ({
    SOPID: shipmentPackage.id,
    Actual_Weight: roundDecimal(shipmentPackage.weight),
    Breadth: roundDecimal(shipmentPackage.breadth),
    Height: roundDecimal(shipmentPackage.height),
    Length: roundDecimal(shipmentPackage.length),
    Packages_of_Same_Weight: shipmentPackage.packageCount,
    Dimension_Unit: mapDimensionsUnitPayload(shipmentPackage.lengthUnit),
    Weight_Unit: mapWeightUnitPayload(shipmentPackage.weightUnit),
    Contains_Batteries: shipmentPackage.hasBatteries,
    DangerousGoods: shipmentPackage.hasDangerousGoods,
  }));
